// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2xcG8","title":"Header_title__3myWA","side":"Header_side__1zK53"};